import { ISliderRanges } from '../slices/types';
import { TypedRootState } from '../types';

export const selectMaxProjectionSliderRanges = (state: TypedRootState): ISliderRanges => state.sliderRanges.maxProjection;
export const selectSingleLayerSliderRanges = (state: TypedRootState): ISliderRanges => state.sliderRanges.singleLayer;
